import { MARQUEE_WORDS } from "@/data";

export default function Marquee() {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section aria-hidden="true" data-testid="marquee-section" className="py-8 md:py-12 bg-brand-peach overflow-hidden border-y border-brand-apricot my-16 md:my-24">
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-3xl md:text-5xl text-brand-ink px-8 md:px-14">
              {w}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-brand-teal" />
          </span>
        ))}
      </div>
    </section>
  );
}
